import TimelineEditor from "component/timeline_editor/timeline_editor";
import React from "react";
import { useSelector } from "react-redux";
import { draftDialogOpenAdvance } from "store/bailiff/draft/dialog/draft_dialog.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogTimeline = () => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------

  // -------------------------- REDUX ---------------------------

  const open = useSelector(draftDialogOpenAdvance);

  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN ----------------------------
  // bg-[#191b1d]
  if (!open) return null;
  return (
    <div className="fixed bottom-0 right-0 !z-[99] flex min-h-[100px] w-[100%] flex-col overflow-hidden border-t-[1px] border-gray-300 bg-white px-5 shadow-sm">
      <TimelineEditor />
    </div>
  );
};
export default DialogTimeline;
